export const I18N_EMOJI = {
  search: 'Pesquisar emoji',
  emojilist: 'Lista de emojis',
  notfound: 'Nenhum emoji encontrado',
  clear: 'Limpar',
  categories: {
    search: 'Resultados',
    recent: 'Recentes',
    people: 'Pessoas',
    nature: 'Natureza',
    foods: 'Comidas',
    activity: 'Atividades',
    places: 'Lugares',
    objects: 'Objetos',
    symbols: 'Símbolos',
    flags: 'Bandeiras',
    custom: 'Personalizados',
  },
  skintones: {},
};
